import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MqttService, IMqttMessage } from 'ngx-mqtt';
import { Subscription, Observable, timer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-mqtt-widget',
  templateUrl: './mqtt-widget.component.html',
  styleUrls: ['./mqtt-widget.component.css'],
  host: { 'class': 'col-lg-12 col-sm-12 d-flex flex-column' }
})
export class MqttWidgetComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private refreshInterval: number = 60 * 1000; // 60s
  private timer: Observable<number>;
  private topic: string = '/callipso/lift/test';
  private message: string;

  public isRunning: boolean = false;
  public testerForm: FormGroup;
  public recievedData: string;
  public recievedTime: string;

  constructor(
    private builder: FormBuilder,
    private mqttService: MqttService
  ) {
    this.testerForm = builder.group({
      'topic': this.topic,
      'interval': 60,
      'data': `{
      id: 5,
      title: "Test title",
      data: [
        {
          name: "Test name",
          count: 65
        },
        {
          name: "Test name2",
          count: 465
        }
      ]
    }
  `
    });
  }

  ngOnInit() {
    this.subscription = this.mqttService.observe('/callipso/lift/test').subscribe((message: IMqttMessage) => {
      const now = moment();
      this.recievedData = message.payload.toString();
      this.recievedTime = now.format('HH:mm:ss');
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleTester() {
    this.isRunning = !this.isRunning;
    this.refreshInterval = this.testerForm.value['interval'] * 1000;
    this.topic = this.testerForm.value['topic'];
    this.message = this.testerForm.value['data'];

    if (this.isRunning) {
      this.initTimer();
    }
  }

  private initTimer() {
    this.timer = timer(0, this.refreshInterval);
    this.timer // Load data in loop by refreshInterval
      .pipe(
        takeWhile(() => this.isRunning)
      )
      .subscribe(() => {
        this.mqttService.unsafePublish(this.topic, this.message, { qos: 1, retain: true });
      });
  }

}
